/* eslint-disable */
import {
  Flex,
  Icon,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Input,
  Button,
  Select,
  HStack,
  Box,
} from "@chakra-ui/react";
// Custom components

import Card from "components/card/Card";
import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  usePagination,
  useSortBy,
  useTable,
  useFilters,
  useAsyncDebounce,
} from "react-table";
import moment from "moment";
import { downloadExcel } from "react-export-table-to-excel";
import {
  convertDateToLocal,
  isNotEmptyData,
  convertCallDurationToMin,
} from "../../../../utils/Utils";
import {
  MdPlayArrow,
  MdDownload,
  MdEdit,
  MdPhone,
  MdLockClock,
} from "react-icons/md";
import CommonModal from "components/modal/CommonModal";
import Window from "floating-window-ui";
import { wfNameAndIdmapping } from "../variables/columnsData";
import {
  downloadAudioFileFromBlob,
  getAnalyticsApiData,
} from "../../../../redux/agent";
import { useSelector, useDispatch } from "react-redux";
import { setLoader } from "../../../../redux/actions/loader";
export default function AnalyticsTablePolicyRenewal(props) {
  const { title, columnsData, tableData, isEvening, updateAnalyticsValue } =
    props;
  const dispatch = useDispatch();
  const columns = useMemo(() => columnsData, [columnsData]);
  const tb = useMemo(() => tableData, [tableData]);
  const [data, setData] = useState([]);
  const [allDataWithoutFilter, setAllDataWithoutFilter] = useState([]);
  const [paginationPageValue, setPaginationPageValue] = useState(0);
  const [highlightEditingRow, setHighlightEditingRow] = useState(null);
  const UTC_DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ss.SSS[Z]";
  const convertToString = (data) => {
    if (data !== null && data !== undefined) {
      return data.toString();
    } else {
      ("");
    }
  };
  // console.log("Table data", tableData);
  useEffect(() => {
    const modifiedDataArray = tableData?.results?.map((dataObject) => {
      let myDate = convertDateToLocal(dataObject.response_time);
      const formatter = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      let callDuration = convertCallDurationToMin(dataObject.callDuration);
      let callAnanlytics = dataObject?.callAnanlytics;
      // console.log("callAnanlytics?.apply_card",convertToString(callAnanlytics.apply_card))
      //convert non string data to string using convertToString() Function
      let modifiedData = {
        phoneNumber: dataObject.userId,
        sessionId: dataObject.sessionId,
        customerName: callAnanlytics?.customer_name,
        productName: callAnanlytics?.product_name,
        language: convertToString(callAnanlytics?.language),
        bankName: convertToString(callAnanlytics?.bank_name),
        agentName: convertToString(callAnanlytics?.agent_name),
        applyingCard: convertToString(callAnanlytics?.apply_card),
        sendSms: convertToString(callAnanlytics?.send_sms),
        call_transfer: convertToString(callAnanlytics?.call_transfer),
        callDuration: convertToString(callDuration),
        callRecording: dataObject?.callRecording,
        response_time: myDate,
      };
      return modifiedData;
    });

    setData(modifiedDataArray);
    setAllDataWithoutFilter(modifiedDataArray);
    filterDataLocally(modifiedDataArray);
  }, [tableData]);

  const getWorkflow = (id) => {
    let res = wfNameAndIdmapping.filter((item) => {
      return id === item.id;
    });
    if (res.length === 1) {
      return res[0].name;
    } else {
      return "";
    }
  };

  const editableField = [
    "totalRetailShop",
    "shopsToBeVisited",
    "focusedProduct",
    "callsMadeToday",
    "productiveCalls",
    "sellValueForToday",
    "officeMeeting",
  ];
  function DefaultColumnFilter({ column: { filterValue, setFilter } }) {
    return (
      <Input
        variant="filled"
        size="sm"
        value={filterValue || ""}
        onChange={(e) => {
          setFilter(e.target.value || undefined);
        }}
        placeholder={"Filter"}
        htmlSize={4}
        width="auto"
      />
    );
  }

  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
      // defaultColumn: { Filter: DefaultColumnFilter },
    },
    useFilters,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    state,
    initialState,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = tableInstance;
  initialState.pageSize = 10;

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const iconColor = useColorModeValue("#2185d0");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isOpenEdit, setIsOpenEdit] = useState(false);
  const [audioVisibility, setAudioVisibility] = useState(false);
  const userData = useSelector((state) => state.userData);
  const [audioUrl, setAudioUrl] = useState("");
  const [valSelectedColForEdit, setSelectedColForEdit] = useState({});
  const [analyticsDataResponse, setAnalyticsDataResponse] = useState(null);
  const [analyticsDataExportList, setAnalyticsDataExportList] = useState([]);
  const editValueRefOne = useRef(null);
  const editValueRefTwo = useRef(null);
  const editValueRefThree = useRef(null);
  const editValueRefFour = useRef(null);

  const audioRef = useRef(null);
  const [custFilterValue, setCustFilterValue] = useState({});

  useEffect(() => {
    setTimeout(() => {
      if (
        isOpenEdit &&
        valSelectedColForEdit?.value &&
        editValueRefOne &&
        editValueRefTwo &&
        editValueRefThree &&
        editValueRefFour
      ) {
        if (isEvening) {
          editValueRefOne.current.value =
            valSelectedColForEdit.value.callsMadeToday;
          editValueRefTwo.current.value =
            valSelectedColForEdit.value.productiveCalls;
          editValueRefThree.current.value =
            valSelectedColForEdit.value.sellValueForToday;
          editValueRefFour.current.value =
            valSelectedColForEdit.value.officeMeeting;
        } else {
          editValueRefOne.current.value =
            valSelectedColForEdit.value.totalRetailShop;
          editValueRefTwo.current.value =
            valSelectedColForEdit.value.shopsToBeVisited;
          editValueRefThree.current.value =
            valSelectedColForEdit.value.focusedProduct;
        }

        // console.log("valSelectedColForEdit",valSelectedColForEdit);
      }
    }, 200);
  }, [isOpenEdit, valSelectedColForEdit]);
  const onOpenEdit = () => {
    setIsOpenEdit(true);
  };

  const onCloseEdit = (isOnSave) => {
    setIsOpenEdit(false);
    if (isOnSave) {
      if (isEvening) {
        valSelectedColForEdit.value.callsMadeToday =
          editValueRefOne.current.value;
        valSelectedColForEdit.value.productiveCalls =
          editValueRefTwo.current.value;
        valSelectedColForEdit.value.sellValueForToday =
          editValueRefThree.current.value;
        valSelectedColForEdit.value.officeMeeting =
          editValueRefFour.current.value.toLowerCase() === "yes" ? true : false;
      } else {
        valSelectedColForEdit.value.totalRetailShop =
          editValueRefOne.current.value;
        valSelectedColForEdit.value.shopsToBeVisited =
          editValueRefTwo.current.value;
        valSelectedColForEdit.value.focusedProduct =
          editValueRefThree.current.value;
      }

      saveEdittedValue();
    }
  };

  const saveEdittedValue = () => {
    updateAnalyticsValue({
      value: valSelectedColForEdit,
      isEvening: isEvening,
    });
  };

  const filterDataLocally = (modifiedDataArray) => {
    let dataArr = [...modifiedDataArray];

    if (Object.keys(custFilterValue).length) {
      dataArr = dataArr.filter(function (item) {
        let trueCounter = 0;
        for (var key in custFilterValue) {
          if (
            item[key] &&
            custFilterValue[key] &&
            item[key].toLowerCase().includes(custFilterValue[key].toLowerCase())
          ) {
            trueCounter++;
            // console.log("trueCounter",trueCounter,Object.keys(custFilterValue).length);
          }
        }
        if (Object.keys(custFilterValue).length === trueCounter) {
          return true;
        }
        return false;
      });
      setData(dataArr);
    } else {
      setData(dataArr);
    }
  };
  useEffect(() => {
    let dataArr = [...allDataWithoutFilter];
    filterDataLocally(dataArr);
  }, [custFilterValue]);

  async function handleDownloadExcel() {
    dispatch(setLoader(true));
    const headersArray = columnsData.map((column) => {
      return column.Header;
    });

    const payload = {
      selectedDateRange: props.selectedDateRange,
      clientName: "NICL",
      scenarioID: "P0001",
      token: userData.token,
      limit: 500,
      page: 1,
      // ...props?.analyticsFilter,
    };
    let genData = [];

    const analyticsDataRes = await getAnalyticsApiData(payload);
    let pagesCount =
      Math.round(Number(analyticsDataRes.data.totalCount) / 500) + 1;
    console.log("Analytics data res", analyticsDataRes.data);
    genData = [...analyticsDataRes.data.results];
    setAnalyticsDataExportList(genData);
    setAnalyticsDataResponse(analyticsDataRes.data);
    async function fetchAndProcessData(payload) {
      const analyticsDataRes = await getAnalyticsApiData(payload);
      genData = [...genData, ...analyticsDataRes.data.results];
      setAnalyticsDataExportList(genData);
    }
    for (let i = 2; i <= pagesCount; i++) {
      setTimeout(() => {
        let Payload = {
          selectedDateRange: props.selectedDateRange,
          clientName: "NICL",
          scenarioID: "P0001",
          token: userData.token,
          limit: 500,
          page: i,
        };
        fetchAndProcessData(Payload);
        console.log("Proceeseed iter ", i);
        console.log("Data List", genData);
      }, 1000 * i);
    }
  }

  function downloadExcelFile() {
    const headersArray = columnsData.map((column) => {
      return column.Header;
    });
    let modifiedDataArray = analyticsDataExportList.map((dataObject) => {
      let myDate = convertDateToLocal(dataObject.response_time);
      const formatter = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      let callDuration = convertCallDurationToMin(dataObject.callDuration);
      let callAnanlytics = dataObject?.callAnanlytics;

      let modifiedData = {
        phoneNumber: dataObject.userId,
        sessionId: dataObject.sessionId,
        customerName: callAnanlytics?.customer_name,

        productName: callAnanlytics?.product_name,
        language: convertToString(callAnanlytics?.language),
        bankName: convertToString(callAnanlytics?.bank_name),
        agentName: convertToString(callAnanlytics?.agent_name),
        applyingCard: convertToString(callAnanlytics?.apply_card),

        sendSms: convertToString(callAnanlytics?.send_sms),
        call_transfer: convertToString(callAnanlytics?.call_transfer),
        callDuration: convertToString(callDuration),
        callRecording: dataObject?.callRecording,
        response_time: myDate,
      };
      return modifiedData;
    });
    console.log("modified data array", modifiedDataArray);

    // console.log("modified data array",modifiedDataArray)
    if (modifiedDataArray?.length) {
      downloadExcel({
        fileName: title.replaceAll(" ", ""),
        sheet: title.replaceAll(" ", ""),
        tablePayload: {
          header: headersArray,
          body: modifiedDataArray,
        },
      });
      setAnalyticsDataExportList([]);
      setAnalyticsDataResponse(null);
    }
  }

  useEffect(() => {
    if (
      analyticsDataResponse &&
      analyticsDataResponse.totalCount === analyticsDataExportList.length
    ) {
      console.log("Reached End");
      downloadExcelFile();
      dispatch(setLoader(false));
    }
  }, [analyticsDataExportList, analyticsDataResponse]);

  const triggerOtherAudioDisplay = () => {
    console.log("trigger other audio display");
    setAudioVisibility(true);
  };
  const getAudioFromBlob = (audioUrl) => {
    console.log("Incoming Audio Url", audioUrl);
    // setAudioUrl(cell.value);
    const audioUrlFromBlob = downloadAudioFileFromBlob(audioUrl);
    console.log("Aduio url", audioUrlFromBlob);
    setAudioUrl(audioUrlFromBlob.url);
  };
  // console.log("Filter inputs",custFilterValue)
  return (
    <Card direction="column" mh="400px" w="100%" px="0px">
      <Flex px="25px" justify="space-between" mb="15px" align="center">
        <Text
          color={textColor}
          fontSize="15px"
          fontWeight="700"
          lineHeight="100%"
        >
          {title}
        </Text>
        <Box className="headRight">
          <Box className="filterButton">
            <Button
              size="sm"
              colorScheme={props.analyticsFilter.isfilter ? "blue" : "black"}
              // leftIcon={<MdDownload />}
              onClick={() => {
                props.applyFilterAnalytisData();
              }}
            >
              Apply Filter
            </Button>
            <Button
              size="sm"
              colorScheme="red"
              // leftIcon={<MdDownload />}
              onClick={() => {
                setCustFilterValue({});
                props.discardFilterAnalytisData();
              }}
            >
              Clear
            </Button>
          </Box>
          <Button
            size="sm"
            colorScheme="blue"
            leftIcon={<MdDownload />}
            onClick={() => {
              handleDownloadExcel();
            }}
          >
            Export
          </Button>
        </Box>
      </Flex>
      <div className="analyticsTable policyRenewal">
        <Table
          {...getTableProps()}
          m="15px auto"
          size="sm"
          variant="striped"
          colorScheme="blackAlpha"
          display="block"
        >
          <Thead>
            {headerGroups.map((headerGroup, index) => (
              <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                {headerGroup.headers.map((column, index) => (
                  <Th
                    // {...column.getHeaderProps(column.getSortByToggleProps())}
                    pe="10px"
                    key={index}
                    borderColor={borderColor}
                  >
                    <Flex
                      justify="space-between"
                      align="center"
                      fontSize="10px"
                      color="gray.400"
                    >
                      {column.render("Header")}
                    </Flex>
                    <span>
                      {column.canFilter ? (
                        <Input
                          variant="filled"
                          size="sm"
                          value={
                            custFilterValue[column.id] &&
                            custFilterValue[column.id].length > 0
                              ? custFilterValue[column.id]
                              : ""
                          }
                          // placeholder={custFilterValue[column.id]?"Ok":"Filter"}
                          onChange={(e) => {
                            if (column.id === "phoneNumber") {
                              props.setAnalyticsFilter({
                                ...props.analyticsFilter,
                                phoneNumber: e.target.value,
                                isfilter:
                                  e.target.value.length === 0 ? false : true,
                              });
                            }
                            if (column.id === "customerName") {
                              props.setAnalyticsFilter({
                                ...props.analyticsFilter,
                                customerName: e.target.value,
                                isfilter:
                                  e.target.value.length === 0 ? false : true,
                              });
                            }
                            if (column.id === "language") {
                              props.setAnalyticsFilter({
                                ...props.analyticsFilter,
                                language: e.target.value,
                                isfilter:
                                  e.target.value.length === 0 ? false : true,
                              });
                            }
                            if (column.id === "sendSms") {
                              props.setAnalyticsFilter({
                                ...props.analyticsFilter,
                                sendSms: e.target.value,
                                isfilter:
                                  e.target.value.length === 0 ? false : true,
                              });
                            }

                            let tempCustFilterRef = Object.assign(
                              {},
                              custFilterValue
                            );
                            if (
                              tempCustFilterRef[column.id] &&
                              e.target.value.length === 0
                            ) {
                              delete tempCustFilterRef[column.id];
                            } else {
                              tempCustFilterRef[column.id] = e.target.value;
                            }
                            setCustFilterValue(tempCustFilterRef);
                          }}
                          placeholder={"Filter"}
                          htmlSize={4}
                          width="auto"
                        />
                      ) : null}
                    </span>
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>
          <Tbody {...getTableBodyProps()} overflow="auto">
            {page.map((row, rowindex) => {
              prepareRow(row);
              return (
                <Tr
                  onClick={() => {
                    console.log("Row clicked");
                  }}
                  {...row.getRowProps()}
                  key={rowindex}
                  style={{
                    border:
                      highlightEditingRow === rowindex ? "solid #000000" : null,
                  }}
                >
                  {row.cells.map((cell, index) => {
                    let data = "";
                    if (cell.column.Header === "Call Recording") {
                      data = (
                        <Flex align="center">
                          <Icon
                            w="24px"
                            h="24px"
                            me="5px"
                            _hover={{ cursor: "pointer" }}
                            _focus={{ boxShadow: "outline" }}
                            as={MdPlayArrow}
                            color={iconColor}
                            onClick={() => {
                              getAudioFromBlob(cell.value);
                              // setAudioUrl(cell.value);
                              onOpen();
                              setSelectedColForEdit({
                                data: cell.row.original,
                              });
                            }}
                          />
                        </Flex>
                      );
                    } else if (editableField.includes(cell.column.id)) {
                      data = (
                        <>
                          <span className="editText">
                            <Text
                              color={textColor}
                              fontSize="sm"
                              fontWeight="700"
                            >
                              {cell.value}
                            </Text>
                            <Icon
                              w="24px"
                              h="24px"
                              me="5px"
                              _hover={{ cursor: "pointer" }}
                              _focus={{ boxShadow: "outline" }}
                              as={MdEdit}
                              color={iconColor}
                              onClick={() => {
                                setHighlightEditingRow(rowindex);
                                setSelectedColForEdit({
                                  sessionId: cell.row.original.sessionId,
                                  id: cell.column.id,
                                  index: cell.row.index,
                                  value: cell.row.original,
                                });
                                onOpenEdit();
                              }}
                            />
                          </span>
                        </>
                      );
                    } else {
                      data = (
                        <>
                          <Text
                            color={textColor}
                            fontSize="sm"
                            fontWeight="700"
                          >
                            {cell.value}
                          </Text>
                        </>
                      );
                    }
                    return (
                      <Td
                        {...cell.getCellProps()}
                        key={index}
                        fontSize={{ sm: "14px" }}
                        minW={{ sm: "150px", md: "20px", lg: "auto" }}
                        borderColor="transparent"
                      >
                        {data}
                      </Td>
                    );
                  })}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </div>
      <div className="pagination" style={{ margin: "25px 30px 0px 25px" }}>
        <HStack className="bottomPagination">
          <div className="pageChangeBtn">
            <Button
              size="sm"
              onClick={() => {
                props.setAnalyticsTablePageNo(1);
              }}
              disabled={!canPreviousPage}
            >
              {"<<"}
            </Button>{" "}
            <Button
              size="sm"
              onClick={() => {
                props.setAnalyticsTablePageNo(props.analyticsTablePageNo - 1);
              }}
              disabled={!canPreviousPage}
            >
              {"<"}
            </Button>{" "}
            <Button
              size="sm"
              onClick={() => {
                props.setAnalyticsTablePageNo(props.analyticsTablePageNo + 1);
              }}
              disabled={!canNextPage}
            >
              {">"}
            </Button>{" "}
            <Button
              size="sm"
              onClick={() => {
                props.setAnalyticsTablePageNo(
                  Math.round(
                    tableData.totalCount / props.pageLimitanalyticsTable
                  )
                );
              }}
              disabled={!canNextPage}
            >
              {">>"}
            </Button>{" "}
          </div>
          <div className="pageCounter">
            <Text fontSize="sm">
              Page{" "}
              <strong>
                {/* {pageIndex + 1} of {pageOptions.length} */}
                {props.analyticsTablePageNo} of
                {Math.round(
                  tableData.totalCount / props.pageLimitanalyticsTable
                )}
              </strong>{" "}
            </Text>
            <span>|</span>
            <Text fontSize="sm">
              Go to page:{" "}
              <Input
                type="number"
                defaultValue={pageIndex + 1}
                onChange={(e) => {
                  const page = e.target.value ? Number(e.target.value) - 1 : 0;
                  props.setAnalyticsTablePageNo(page);
                }}
                variant="filled"
                size="xs"
                width="20%"
              />
            </Text>
            <Select
              value={props.pageLimitanalyticsTable}
              onChange={(e) => {
                props.setLimitAnalyticsTable(Number(e.target.value));
                setPageSize(Number(e.target.value));
              }}
              variant="filled"
              size={"xs"}
              width={"auto"}
            >
              {[10, 50, 100].map((pageSize) => (
                <option key={pageSize} value={pageSize}>
                  Show {pageSize}
                </option>
              ))}
            </Select>
          </div>
        </HStack>
      </div>

      {isOpen && (
        <>
          <Modal
            isOpen={isOpen}
            onClose={() => {
              onClose();
              setAudioVisibility(false);
            }}
          >
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>Audio</ModalHeader>

              <ModalBody style={{ height: "40em" }}>
                {/* controlsList="nodownload" */}
                <Text fontSize="sm">
                  Customer Name : {valSelectedColForEdit?.data?.customerName}
                </Text>
                <Text fontSize="sm">
                  Phone Number : {valSelectedColForEdit?.data?.phoneNumber}
                </Text>
                <Text fontSize="sm">
                  Session Id : {valSelectedColForEdit?.data?.sessionId}
                </Text>
                <br></br>
                <figure style={{ margin: "10px auto" }}>
                  <audio
                    preload="auto"
                    src={audioUrl}
                    onCanPlayThrough={() => triggerOtherAudioDisplay()}
                  ></audio>
                  {audioVisibility ? (
                    <audio
                      controls
                      style={{ width: "100%" }}
                      src={audioUrl}
                      ref={audioRef}
                    >
                      {/* <a href="/media/cc0-audio/t-rex-roar.mp3">Download audio</a> */}
                    </audio>
                  ) : null}
                </figure>
              </ModalBody>

              <ModalFooter>
                <Button
                  onClick={() => {
                    onClose();
                    setAudioVisibility(false);
                  }}
                >
                  Cancel
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </>
      )}

      {isOpenEdit && (
        <Window
          id="react-window-audio"
          height={440}
          width={600}
          resizable={true}
          titleBar={{
            title: "Analytics Data Editing",
            buttons: {
              minimize: false,
              maximize: false,
              close: () => {
                onCloseEdit(false);
                setAudioVisibility(false);
                setHighlightEditingRow(null);
              },
            },
          }}
        >
          <div className="editAudioModal">
            <div className="infoHeader">
              <div className="phoneNumb">
                <Icon
                  w="16px"
                  h="16px"
                  me="5px"
                  _hover={{ cursor: "pointer" }}
                  _focus={{ boxShadow: "outline" }}
                  as={MdPhone}
                  color={iconColor}
                  onClick={() => {}}
                />
                <Text>{`${valSelectedColForEdit.value.phoneNumber} (${valSelectedColForEdit.value.sessionId})`}</Text>
              </div>
              <div className="timeCircle">
                <Icon
                  w="16px"
                  h="16px"
                  me="5px"
                  _hover={{ cursor: "pointer" }}
                  _focus={{ boxShadow: "outline" }}
                  as={MdLockClock}
                  color={iconColor}
                  onClick={() => {}}
                />
                <Text>{valSelectedColForEdit.value.timestamp}</Text>
              </div>
            </div>

            <div className="editAudio">
              <figure style={{ margin: "10px auto" }}>
                <audio
                  preload="auto"
                  src={valSelectedColForEdit.value.callRecording}
                  onCanPlayThrough={() => triggerOtherAudioDisplay()}
                ></audio>
                {audioVisibility ? (
                  <audio
                    controls
                    style={{ width: "100%" }}
                    src={valSelectedColForEdit.value.callRecording}
                    ref={audioRef}
                  >
                    {/* <a href="/media/cc0-audio/t-rex-roar.mp3">Download audio</a> */}
                  </audio>
                ) : null}
              </figure>
            </div>
            <div className="editOptions">
              {isEvening && (
                <div className="formGroup">
                  <div className="rowBlock">
                    <label className="colLeft">{columnsData[5].Header}</label>
                    <div className="colRight">
                      <Input
                        className="form-control"
                        ref={editValueRefFour}
                        variant="filled"
                        size="lg"
                        placeholder={"Value"}
                        width="auto"
                      />
                    </div>
                  </div>
                </div>
              )}
              <div className="formGroup">
                <div className="rowBlock">
                  <label className="colLeft">
                    {isEvening ? columnsData[6].Header : columnsData[5].Header}
                  </label>
                  <div className="colRight">
                    <Input
                      className="form-control"
                      ref={editValueRefOne}
                      variant="filled"
                      size="lg"
                      placeholder={"Value"}
                      width="auto"
                    />
                  </div>
                </div>
              </div>
              <div className="formGroup">
                <div className="rowBlock">
                  <label className="colLeft">
                    {isEvening ? columnsData[7].Header : columnsData[6].Header}
                  </label>
                  <div className="colRight">
                    <Input
                      className="form-control"
                      ref={editValueRefTwo}
                      variant="filled"
                      size="lg"
                      placeholder={"Value"}
                      width="auto"
                    />
                  </div>
                </div>
              </div>
              <div className="formGroup">
                <div className="rowBlock">
                  <label className="colLeft">
                    {isEvening ? columnsData[9].Header : columnsData[7].Header}
                  </label>
                  <div className="colRight">
                    <Input
                      className="form-control"
                      ref={editValueRefThree}
                      variant="filled"
                      size="lg"
                      placeholder={"Value"}
                      width="auto"
                    />
                  </div>
                </div>
              </div>
              <div className="formGroup textAlignRight">
                <Button
                  colorScheme="blue"
                  mr={3}
                  onClick={() => {
                    onCloseEdit(true);
                    setHighlightEditingRow(null);
                  }}
                >
                  Save
                </Button>
              </div>
            </div>
          </div>
        </Window>
      )}
    </Card>
  );
}
